export enum PreviewPageTab {
  DETAILS = 'details',
  FILES = 'dateien'
}
